import quotationCard from './quotationCard/pt-BR';
import cardImpl from './CardImpl/pt-BR';

const componentsModule = {
  ...quotationCard,
  ...cardImpl,
};

export default componentsModule;
